function hasText(value) {
    return typeof value === 'string' && value.trim().length > 0;
}

function extractMessageFromObject(data) {
    if (!data || typeof data !== 'object' || Array.isArray(data)) {
        return '';
    }

    const keys = ['message', 'error', 'details', 'responseResult', 'code'];

    for (const key of keys) {
        if (hasText(data[key])) {
            return data[key].trim();
        }
    }

    if (Array.isArray(data.errors) && data.errors.length > 0) {
        const firstError = data.errors.find((item) => hasText(item));
        if (firstError) {
            return firstError.trim();
        }
    }

    return '';
}

function getErrorMessage(error, fallbackMessage = 'Nao foi possivel concluir a operacao.') {
    if (hasText(error)) {
        return error.trim();
    }

    if (hasText(error && error.userMessage)) {
        return error.userMessage.trim();
    }

    const response = error && error.response;
    const data = response && response.data;

    if (hasText(data)) {
        return data.trim();
    }

    const objectMessage = extractMessageFromObject(data);
    if (objectMessage) {
        return objectMessage;
    }

    if (response && response.status === 401) {
        return 'Sua sessao expirou ou as credenciais sao invalidas.';
    }

    if (response && response.status === 403) {
        return 'Voce nao tem permissao para executar esta acao.';
    }

    if (response && response.status === 404) {
        return 'O recurso solicitado nao foi encontrado.';
    }

    if (error && error.code === 'ECONNABORTED') {
        return 'A requisicao demorou mais do que o esperado.';
    }

    if (error && error.message === 'Network Error') {
        return 'Nao foi possivel conectar ao servidor. Verifique se o backend esta online.';
    }

    if (!response) {
        return 'Nao foi possivel conectar ao servidor. Verifique se o backend esta online.';
    }

    if (hasText(error && error.message) && !/status code \d+/i.test(error.message)) {
        return error.message.trim();
    }

    return fallbackMessage;
}

export {
    getErrorMessage
};
